import styled, { css } from 'styled-components/macro';

export const RadioInputDiv = styled.div`
  margin: 20px 0;
  ${props =>
    props.readOnly &&
    css`
      border-bottom-color: transparent;
    `}
`;

export const RadioInputLabelH5 = styled.h5`
  margin: 3.3rem 0 1.2rem;
`;

export const ValidationSmall = styled.small`
  color: ${props => props.theme.red};
  margin-left: 10px;
`;

export const RadioOptionDiv = styled.div`
  padding: 4px 0;
  /* display: flex; */
  input {
    visibility: hidden;
    position: absolute;
  }
`;

export const RadioOptionLabel = styled.label`
  line-height: 1.2rem;
  > span {
    color: ${props => props.theme.dustyGray};
    overflow-wrap: break-word;
  }
`;

const outerSize = 1.2;
const spacing = 0.1;
export const RadioOuter = styled.div`
  height: ${outerSize}rem;
  width: ${outerSize}rem;
  border: ${props => props.theme.defaultBorder};
  border-radius: ${outerSize / 2}rem;
  display: inline-block;
  margin-bottom: 0.8rem;
  margin-right: 0.8rem;
  &:hover {
    ${props =>
    !props.readOnly &&
      css`
        border-color: ${props => props.theme.blue};
      `};
  }

  ${props =>
    props.checked &&
    css`
      border-color: ${props => props.theme.blue};
      ${props =>
    props.readOnly &&
        css`
          border-color: ${props => props.theme.dustierGray};
        `};
    `}
`;

export const RadioInner = styled.div`
  height: ${outerSize - 2 * spacing - 0.2}rem;
  width: ${outerSize - 2 * spacing - 0.2}rem;
  margin-top: ${spacing}rem;
  margin-left: ${spacing}rem;
  background-color: ${props => props.theme.blue};
  border-radius: 0.5rem;
  ${props =>
    props.readOnly &&
    css`
      background-color: ${props => props.theme.dustierGray};
    `};
`;
